import { compose } from 'recompose'
import { withStyles } from '@material-ui/core';

import { connect } from 'react-redux'
import withAuthentication from '../../../components/withAuthentication';
import styles from './styles'
import { withUser } from '../../../components/Utils';
import { actionsAfterLogin } from '../../functions';

const mapStateToProps = (state, props) => {

    return {};
};

export default compose(
    withStyles(styles, { withTheme: true }),
    withAuthentication,    
    connect(mapStateToProps, {actionsAfterLogin}),
    withUser
);


// WEBPACK FOOTER //
// ./src/App/components/Layout/Layout.enhancer.js